import type { EngineHeroProps, EngineModule } from "../types";

function Hero({ domain, nodes, onSelect, selectedKey }: EngineHeroProps) {
  if (!nodes.length) {
    return (
      <div className="rounded-2xl border hairline p-8 text-center text-sm text-foreground/60">
        {domain.name} — explore the paths below.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {nodes.map((n) => {
        const active = selectedKey === n.key;
        return (
          <button
            key={n.id}
            type="button"
            onClick={() => onSelect?.(n)}
            className={
              "min-h-[88px] rounded-xl border hairline p-4 text-left transition " +
              (active ? "border-gold/70 bg-gold/10" : "hover:border-gold/40")
            }
          >
            <div className="font-serif text-gold-luminous">{n.label}</div>
            {n.description && (
              <p className="mt-1 line-clamp-2 text-xs text-foreground/60">{n.description}</p>
            )}
          </button>
        );
      })}
    </div>
  );
}

export const genericEngine: EngineModule = { label: "Generic Grid", Hero };
